// extracted by mini-css-extract-plugin
module.exports = {"link":"Fasting_link__3gXrf","container":"Fasting_container__1zy1k"};